import React, { Component, Fragment } from "react";
import Link from "./Link";
import LoadingSkeleton from "./LoadingSkeleton";
import { Query } from "react-apollo";
import gql from "graphql-tag";
import { LINKS_PER_PAGE, USER_ID } from "../constants";
import { repliesFragmentForCounting } from "../utils"
// import {
//   NEW_COMMENTS_SUBSCRIPTION,
//   UNCOMMENT_SUBSCRIPTION,
// } from "./LinkDetails";

export const FEED_QUERY = gql`
  query FeedQuery($first: Int, $skip: Int, $orderBy: LinkOrderByInput) {
    feed(first: $first, skip: $skip, orderBy: $orderBy) {
      links {
        id
        created
        url
        description
        ranking
        postedBy {
          id
          name
        }
        votes {
          id
          user {
            id
          }
        }
        comments {
          id
          ${repliesFragmentForCounting}
        }
      }
      count
    }
  }
`;

// export const NEW_LINKS_SUBSCRIPTION = gql`
//   subscription {
//     newLink {
//       id
//       created
//       url
//       description
//       ranking
//       postedBy {
//         id
//         name
//       }
//       votes {
//         id
//         user {
//           id
//         }
//       }
//       comments {
//         id
//       }
//     }
//   }
// `;

// const REMOVED_LINK_SUBSCRIPTION = gql`
//   subscription {
//     removedLink {
//       id
//     }
//   }
// `;

// export const NEW_VOTES_SUBSCRIPTION = gql`
//   subscription {
//     newVote {
//       id
//       link {
//         id
//         url
//         description
//         created
//         postedBy {
//           id
//           name
//         }
//         votes {
//           id
//           user {
//             id
//           }
//         }
//         comments {
//           id
//         }
//       }
//       user {
//         id
//       }
//     }
//   }
// `;

// export const UNVOTES_SUBSCRIPTION = gql`
//   subscription {
//     unVote {
//       id
//       link {
//         id
//         url
//         description
//         created
//         postedBy {
//           id
//           name
//         }
//         votes {
//           id
//           user {
//             id
//           }
//         }
//         comments {
//           id
//         }
//       }
//       user {
//         id
//       }
//     }
//   }
// `;

class LinkList extends Component {
  _updateCacheAfterVote = (store, voteData, linkId) => {
    const isNewPage = this.props.location.pathname.includes("new");
    const page = parseInt(this.props.match.params.page, 10);

    const skip = isNewPage ? (page - 1) * LINKS_PER_PAGE : 0;
    const first = LINKS_PER_PAGE;
    // const orderBy = this.props.location.pathname.includes("new")
    //   ? "created_DESC"
    //   : this.props.location.pathname.includes("top")
    //   ? "ranking_DESC"
    //   : null;
    let topFeed;
    try {
      topFeed = store.readQuery({
        query: FEED_QUERY,
        variables: { orderBy: "ranking_DESC", first, skip: 0 },
      });
      topFeed.orderBy = "ranking_DESC";
    } catch (err) {
      topFeed = null;
    }

    let newFeed;
    try {
      newFeed = store.readQuery({
        query: FEED_QUERY,
        variables: { first, skip, orderBy: "created_DESC" },
      });
      newFeed.orderBy = "created_DESC";
    } catch (err) {
      newFeed = null;
    }

    const feeds = [topFeed, newFeed].filter((feed) => feed);
    feeds.forEach((_feed) => {
      const link = _feed.feed.links.find((link) => link.id === linkId);
      link.votes = voteData.vote
        ? voteData.vote.link.votes
        : link.votes.filter((vote) => {
          return vote.id !== voteData.unvote.id;
        });
      store.writeQuery({
        query: FEED_QUERY,
        data: _feed,
        variables: { first, skip, orderBy: _feed.orderBy },
      });
    });
  };

  // _subscribeToNewLinks = (subscribeToMore) => {
  //   subscribeToMore({
  //     document: NEW_LINKS_SUBSCRIPTION,
  //     updateQuery: (prev, { subscriptionData }) => {
  //       if (!subscriptionData.data) return prev;
  //       const newLink = subscriptionData.data.newLink;
  //       const exists = prev.feed.links.find(({ id }) => id === newLink.id);
  //       if (exists) return prev;

  //       return Object.assign({}, prev, {
  //         feed: {
  //           links: [newLink, ...prev.feed.links],
  //           count: prev.feed.links.length + 1,
  //           __typename: prev.feed.__typename,
  //         },
  //       });
  //     },
  //   });
  // };

  // _subscribeToRemovedLinks = (subscribeToMore) => {
  //   subscribeToMore({
  //     document: REMOVED_LINK_SUBSCRIPTION,
  //     updateQuery: (prev, { subscriptionData }) => {
  //       if (!subscriptionData.data) return prev;

  //       const deletedLink = subscriptionData.data.removedLink;
  //       const exists = prev.feed.links.find(
  //         (link) => link.id === deletedLink.id
  //       );
  //       if (!exists) return prev;

  //       return Object.assign({}, prev, {
  //         feed: {
  //           links: prev.feed.links.filter((link) => link.id !== deletedLink.id),
  //           count: prev.feed.links.length - 1,
  //           __typename: prev.feed.__typename,
  //         },
  //       });
  //     },
  //   });
  // };

  // _subscribeToNewVotes = (subscribeToMore) => {
  //   subscribeToMore({
  //     document: NEW_VOTES_SUBSCRIPTION,
  //   });
  // };

  // _subscribeToUnVotes = (subscribeToMore) => {
  //   subscribeToMore({
  //     document: UNVOTES_SUBSCRIPTION,
  //     updateQuery: (prev, { subscriptionData }) => {
  //       if (!subscriptionData.data) return prev;

  //       const deletedVote = subscriptionData.data.unVote;
  //       const exists = prev.feed.links
  //         .map((link) => link.votes)
  //         .flat()
  //         .find(({ id }) => id === deletedVote.id);
  //       if (!exists) return prev;

  //       const linksUnVoted = prev.feed.links.map((link) => {
  //         link.votes = link.votes.filter(({ id }) => id !== deletedVote.id);
  //         return link;
  //       });

  //       return Object.assign({}, prev, {
  //         feed: {
  //           links: linksUnVoted,
  //           count: prev.feed.links.length + 1,
  //           __typename: prev.feed.__typename,
  //         },
  //       });
  //     },
  //   });
  // };

  // _subscribeToNewComments = (subscribeToMore) => {
  //   subscribeToMore({
  //     document: NEW_COMMENTS_SUBSCRIPTION,
  //   });
  // };

  // _subscribeToDeletedComments = (subscribeToMore) => {
  //   subscribeToMore({
  //     document: UNCOMMENT_SUBSCRIPTION,
  //     updateQuery: (prev, { subscriptionData }) => {
  //       if (!subscriptionData.data) return prev;

  //       const deletedComment = subscriptionData.data.unComment;
  //       const exists = prev.feed.links
  //         .map((link) => link.comments)
  //         .flat()
  //         .find(({ id }) => id === deletedComment.id);
  //       if (!exists) return prev;

  //       const linksUnCommented = prev.feed.links.map((link) => {
  //         link.comments = link.comments.filter(
  //           ({ id }) => id !== deletedComment.id
  //         );
  //         return link;
  //       });

  //       return Object.assign({}, prev, {
  //         feed: {
  //           links: linksUnCommented,
  //           count: prev.feed.links.length + 1,
  //           __typename: prev.feed.__typename,
  //         },
  //       });
  //     },
  //   });
  // };

  _getQueryVariables = () => {
    const shouldPaginate = !!this.props.match.params.page;
    const page = parseInt(this.props.match.params.page, 10);
    const skip = shouldPaginate ? (page - 1) * LINKS_PER_PAGE : 0;
    const first = shouldPaginate ? LINKS_PER_PAGE : 100;
    const orderBy = this.props.location.pathname.includes("new")
      ? "created_DESC"
      : "ranking_DESC";
    return { first, skip, orderBy };
  };

  _nextPage = (data) => {
    const page = parseInt(this.props.match.params.page, 10);
    if (page <= data.feed.count / LINKS_PER_PAGE) {
      const listType = this.props.location.pathname.includes("new")
        ? "new"
        : "top";
      const nextPage = page + 1;
      this.props.history.push(`/${listType}/${nextPage}`);
    }
  };

  _previousPage = () => {
    const page = parseInt(this.props.match.params.page, 10);
    if (page > 1) {
      const previousPage = page - 1;
      const listType = this.props.location.pathname.includes("new")
        ? "new"
        : "top";
      this.props.history.push(`/${listType}/${previousPage}`);
    }
  };
  render() {
    return (
      <Query query={FEED_QUERY} variables={this._getQueryVariables()}>
        {({ loading, error, data }) => { //subscribeToMore
          if (loading) return <LoadingSkeleton />;
          if (error) return <div className="mt2">Error</div>;

          // this._subscribeToNewLinks(subscribeToMore);
          // this._subscribeToRemovedLinks(subscribeToMore);
          // this._subscribeToNewVotes(subscribeToMore);
          // this._subscribeToUnVotes(subscribeToMore);
          // this._subscribeToNewComments(subscribeToMore);
          // this._subscribeToDeletedComments(subscribeToMore);

          const linksToRender = data.feed ? data.feed.links : [];
          const shouldPaginate =
            !!this.props.match.params.page &&
            data.feed &&
            data.feed.count > LINKS_PER_PAGE;
          const pageIndex = this.props.match.params.page
            ? (this.props.match.params.page - 1) * LINKS_PER_PAGE
            : 0;
          return (
            <Fragment>
              {linksToRender.map((link, index) => (
                <Link
                  key={link.id}
                  link={link}
                  index={index + pageIndex}
                  updateStoreAfterVote={this._updateCacheAfterVote}
                  votable={
                    link.postedBy
                      ? localStorage.getItem(USER_ID) !== link.postedBy.id
                      : true
                  }
                />
              ))}
              {shouldPaginate && (
                <div className="flex v3 gray mt2 mb1">
                  {pageIndex > 0 && (
                    <div className="pointer mr2" onClick={this._previousPage}>
                      Previous
                    </div>
                  )}

                  {data.feed.count -
                    LINKS_PER_PAGE *
                    parseInt(this.props.match.params.page, 10) >
                    0 && (
                      <div
                        className="pointer"
                        onClick={() => this._nextPage(data)}
                      >
                        Next
                      </div>
                    )}
                </div>
              )}
            </Fragment>
          );
        }}
      </Query>
    );
  }
}

export default LinkList;



// WEBPACK FOOTER //
// ./src/components/LinkList.js